import { useMemo, useState } from "react";
import { newsList } from "@/mocks/celebrityData";

const tabs = ["全部", "剧集动态", "音乐现场", "红毯造型", "行业观察", "人物动态"];

export default function NewsFeed() {
  const [active, setActive] = useState("全部");
  const list = useMemo(
    () => (active === "全部" ? newsList : newsList.filter((n) => n.category === active)),
    [active]
  );

  return (
    <section id="news" className="bg-paper-100" aria-label="资讯精选">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-crimson-500">
              <i className="ri-flashlight-line" aria-hidden="true"></i> 今日精选
            </span>
            <h2 className="mt-2 font-serif text-3xl font-black text-ink-950 md:text-4xl">热点资讯流</h2>
            <p className="mt-2 max-w-xl text-sm text-ink-600">
              按话题热度排序的公开娱乐报道，覆盖剧集、音乐、红毯与行业动态，点击标签即可切换栏目。
            </p>
          </div>
        </div>

        <div className="mt-7 flex gap-2 overflow-x-auto no-scrollbar pb-1">
          {tabs.map((t) => (
            <button
              key={t}
              onClick={() => setActive(t)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition ${
                active === t
                  ? "bg-ink-950 text-white"
                  : "border border-paper-200 bg-white text-ink-600 hover:border-crimson-100 hover:text-crimson-500"
              }`}
            >
              {t}
            </button>
          ))}
        </div>

        <div className="mt-7 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {list.map((item) => (
            <article
              key={item.id}
              className="group flex flex-col overflow-hidden rounded-2xl border border-paper-200 bg-white transition hover:-translate-y-1 hover:border-amber2-100"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.title}配图`}
                  className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-crimson-500 px-2.5 py-1 text-[11px] font-semibold text-white">
                  {item.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <div className="flex items-center justify-between text-xs text-ink-400">
                  <span className="font-medium text-amber2-600">{item.category}</span>
                  <span>{item.time}</span>
                </div>
                <h3 className="mt-2 font-serif text-base font-bold leading-snug text-ink-900 line-clamp-2 group-hover:text-crimson-500">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs leading-relaxed text-ink-600 line-clamp-2 hidden sm:block">
                  {item.excerpt}
                </p>
                <div className="mt-auto flex items-center gap-1.5 pt-3 text-xs text-ink-400">
                  <i className="ri-fire-line text-crimson-400" aria-hidden="true"></i>
                  <span>热度 {item.hot}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}